import React, { useState, useEffect } from "react";
import { db, auth } from "./firebase";
import {
  collection,
  getDocs,
  addDoc,
  deleteDoc,
  doc,
  getDoc,
  query,
  where,
  setDoc,
  onSnapshot
} from "firebase/firestore";
import { createUserWithEmailAndPassword, deleteUser, signInWithEmailAndPassword } from "firebase/auth";
import { initializeApp, deleteApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";
import Navbar from "./Navbar";
import "./navbar-spacing.css";
import "./Dashboard.css";

function GestioneCamerieri() {
  const [user] = useAuthState(auth);
  const [localeTag, setLocaleTag] = useState("");
  const [limiteCamerieri, setLimiteCamerieri] = useState(null);
  const [camerieri, setCamerieri] = useState([]);
  const [nomeCameriere, setNomeCameriere] = useState("");
  const [messaggio, setMessaggio] = useState("");
  const [categorie, setCategorie] = useState([]);
  const [modaleCategoria, setModaleCategoria] = useState(null);
  const [categorieSelezionate, setCategorieSelezionate] = useState([]);
  const [popupLimitePiatti, setPopupLimitePiatti] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchLocale = async () => {
      if (!user) {
        navigate("/login");
        return;
      }

      const docRef = doc(db, "utenti", user.uid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const tag = docSnap.data().localeTag;
        setLocaleTag(tag);

        // 🔴 BLOCCO CAMERIERI
        const localeRef = doc(db, "locali", tag);
        const localeSnap = await getDoc(localeRef);

        if (localeSnap.exists()) {
          const data = localeSnap.data();
setLimiteCamerieri(
  data.limiteCamerieri ?? null
);
          if (data.nascondiCamerieri) {
            navigate("/");
            return;
          }
        }
      }
    };

    fetchLocale();
  }, [user, navigate]);

  useEffect(() => {
  if (!localeTag) return;

  const q = query(
    collection(db, "camerieri"),
    where("localeTag", "==", localeTag)
  );

  const unsubscribe = onSnapshot(
    q,
    (snapshot) => {
      const lista = snapshot.docs.map((d) => ({
        id: d.id,
        ...d.data()
      }));

      setCamerieri(lista);
    },
    (error) => {
      console.error("Errore aggiornamento camerieri:", error);
    }
  );

  return () => unsubscribe();
}, [localeTag]);

  // Carica categorie dal menu
  useEffect(() => {
    if (!localeTag) return;
    const fetchCategorie = async () => {
      const snapshot = await getDocs(collection(db, "categorie"));
      const lista = snapshot.docs
        .filter(d => d.data().localeTag === localeTag)
        .map(d => d.data().nome);
      setCategorie([...new Set(lista)]);
    };
    fetchCategorie();
  }, [localeTag]);

  const aggiungiCameriere = async () => {
    if (!nomeCameriere.trim()) {
      setMessaggio("❌ Inserisci un nome");
      setTimeout(() => setMessaggio(""), 3000);
      return;
    }
if (
  limiteCamerieri !== null &&
  camerieri.length >= limiteCamerieri
) {
  setMessaggio(
    "⚠️ Hai raggiunto il numero massimo di camerieri previsto per il tuo locale."
  );

  setTimeout(() => {
    setMessaggio("");
  }, 3000);

  return;
}
    try {
      // Genera credenziali univoche per il cameriere
      const safeLocaleTag = localeTag
  .toLowerCase()
  .replace(/[^a-z0-9]/g, "");

const emailCameriere =
  `cameriere_${Date.now()}@${safeLocaleTag}.qrmenu.local`;
      const passwordCameriere = `cam_${Math.random().toString(36).substring(2, 15)}`;
      
      // Crea una seconda istanza Firebase per creare l'utente senza disconnettere il gestore
      const secondaryApp = initializeApp({
        apiKey: "AIzaSyDptMS51bB06TpfuDqh62WW0-n79xT2uTU",
        authDomain: "qrzone-menuvivo.firebaseapp.com",
        projectId: "qrzone-menuvivo",
        storageBucket: "qrzone-menuvivo.firebasestorage.app",
        messagingSenderId: "995856566219",
        appId: "1:995856566219:web:b612732716e1492833584e"
      }, "Secondary");
      
      const secondaryAuth = getAuth(secondaryApp);
      
      // Crea account Firebase Auth usando l'istanza secondaria
      const userCredential = await createUserWithEmailAndPassword(secondaryAuth, emailCameriere, passwordCameriere);
      const cameriereUid = userCredential.user.uid;
      
      // Ora crea i documenti Firestore (tu sei ancora loggato come gestore nell'istanza principale)
      await setDoc(doc(db, "utenti", cameriereUid), {
        email: emailCameriere,
        ruolo: "cameriere",
        localeTag: localeTag,
        nome: nomeCameriere.trim()
      });
      
      await setDoc(doc(db, "camerieri", cameriereUid), {
        nome: nomeCameriere.trim(),
        localeTag: localeTag,
        email: emailCameriere,
        password: passwordCameriere,
        createdAt: new Date()
      });
      
      // Cleanup: elimina l'app secondaria
      await deleteApp(secondaryApp);
      
      setNomeCameriere("");
      setMessaggio("✅ Cameriere aggiunto con successo!");
      setTimeout(() => setMessaggio(""), 3000);
      
      // Ricarica lista
      const q = query(collection(db, "camerieri"), where("localeTag", "==", localeTag));
      const snapshot = await getDocs(q);
      const lista = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
      setCamerieri(lista);
    } catch (error) {
      console.error("Errore:", error);
      if (error.code === 'auth/email-already-in-use') {
        setMessaggio("❌ Errore: email già in uso");
      } else if (error.code === 'permission-denied') {
        setMessaggio("❌ Errore: permessi insufficienti");
      } else {
        setMessaggio(`❌ Errore: ${error.message}`);
      }
      setTimeout(() => setMessaggio(""), 5000);
    }
  };

  const eliminaCameriere = async (id) => {
    if (!window.confirm("Eliminare questo cameriere? Verrà rimosso anche il suo account.")) return;
    
    try {
      // Recupera i dati del cameriere per l'email
      const cameriereDoc = await getDoc(doc(db, "camerieri", id));
      
      if (cameriereDoc.exists()) {
        const cameriereData = cameriereDoc.data();
        
        // Tenta di eliminare l'account Auth (richiede re-login temporaneo)
        if (cameriereData.email && cameriereData.password) {
          try {
            // Salva l'utente corrente
            const currentUser = auth.currentUser;
            
            // Login temporaneo come cameriere per poterlo eliminare
            const { user: cameriereUser } = await signInWithEmailAndPassword(
              auth, 
              cameriereData.email, 
              cameriereData.password
            );
            
            // Elimina l'account Auth
            await deleteUser(cameriereUser);
            
            // Re-login dell'utente originale (gestore/admin)
            // Nota: l'utente dovrà eventualmente rifare login manualmente
            console.log("✅ Account Auth del cameriere eliminato");
          } catch (authError) {
            console.warn("⚠️ Impossibile eliminare account Auth (potrebbe essere già eliminato):", authError.code);
            // Continua comunque con l'eliminazione da Firestore
          }
        }
      }
      
      // Elimina documenti Firestore
      await deleteDoc(doc(db, "camerieri", id));
      await deleteDoc(doc(db, "utenti", id)); // Elimina anche da utenti
      
      setCamerieri(camerieri.filter(c => c.id !== id));
      setMessaggio("✅ Cameriere e account eliminati");
      setTimeout(() => setMessaggio(""), 3000);
      
      // Forza reload se l'operazione ha fatto logout
      if (!auth.currentUser) {
        window.location.reload();
      }
    } catch (error) {
      console.error("Errore:", error);
      setMessaggio(`❌ Errore eliminazione: ${error.code || error.message}`);
      setTimeout(() => setMessaggio(""), 5000);
    }
  };

  const salvaCategoriaNotifica = async (cameriereId) => {
    try {
      const cameriereRef = doc(db, "camerieri", cameriereId);
      await setDoc(cameriereRef, {
        categorieNotifica: categorieSelezionate.length > 0 ? categorieSelezionate : []
      }, { merge: true });

      setCamerieri(prev => prev.map(c => 
        c.id === cameriereId 
          ? { ...c, categorieNotifica: categorieSelezionate.length > 0 ? categorieSelezionate : [] }
          : c
      ));

      const messaggioCategorie = categorieSelezionate.length > 0 
        ? categorieSelezionate.join(", ") 
        : "Nessuna";
      setMessaggio(`✅ Categorie "${messaggioCategorie}" assegnate al cameriere`);
      setModaleCategoria(null);
      setCategorieSelezionate([]);
      setTimeout(() => setMessaggio(""), 3000);
    } catch (error) {
      console.error("Errore salvataggio categoria:", error);
      setMessaggio("❌ Errore nel salvataggio");
      setTimeout(() => setMessaggio(""), 3000);
    }
  };

  return (
    <>
      <Navbar />
      <div className="page-with-navbar" style={{ padding: "2rem", paddingTop: "6rem", maxWidth: "1200px", margin: "0 auto" }}>
        <h2 style={{ marginBottom: "1.5rem" }}>👨‍🍳 Gestione Camerieri</h2>

        {/* QR GENERICO PWA CAMERIERE */}
        <div style={{
          padding: "1rem",
          backgroundColor: "var(--color-surface)",
          borderRadius: "10px",
          marginBottom: "1.5rem",
          boxShadow: "0 1px 6px rgba(0,0,0,0.08)",
          textAlign: "center",
          maxWidth: "420px",
          marginLeft: "auto",
          marginRight: "auto"
        }}>
          <h3 style={{ marginTop: 0 }}>📲 Installa App Cameriere</h3>

          <QRCodeCanvas 
            value="https://waiter-qrmenu.web.app"
            size={120}
            level="M"
            includeMargin={true}
          />

          <p style={{ fontSize: "0.8rem", color: "#777", marginTop: "0.6rem" }}>
            1️⃣ Apri • 2️⃣ Installa • 3️⃣ Usa il tuo QR personale
          </p>
        </div>

        {messaggio && (
          <div style={{
            padding: "1rem",
            marginBottom: "1.5rem",
            backgroundColor: messaggio.includes("✅") ? "#4CAF50" : "#f44336",
            color: "white",
            borderRadius: "8px",
            textAlign: "center"
          }}>
            {messaggio}
          </div>
        )}

        {/* Form aggiungi cameriere */}
        <div style={{
          padding: "1.5rem",
          backgroundColor: "var(--color-surface)",
          borderRadius: "12px",
          marginBottom: "2rem",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
        }}>
          <h3 style={{ marginTop: 0, marginBottom: "1rem" }}>➕ Nuovo Cameriere</h3>
          <div style={{ display: "flex", gap: "1rem", alignItems: "center", flexWrap: "wrap" }}>
            <input
              type="text"
              placeholder="Nome cameriere"
              value={nomeCameriere}
              onChange={(e) => setNomeCameriere(e.target.value)}
              onKeyPress={(e) => e.key === "Enter" && aggiungiCameriere()}
              style={{
                flex: 1,
                minWidth: "200px",
                padding: "0.75rem",
                border: "2px solid #ddd",
                borderRadius: "8px",
                fontSize: "1rem"
              }}
            />
            <button
              onClick={aggiungiCameriere}
              style={{
                padding: "0.75rem 2rem",
                backgroundColor: "#4CAF50",
                color: "white",
                border: "none",
                borderRadius: "8px",
                fontSize: "1rem",
                fontWeight: "bold",
                cursor: "pointer"
              }}
            >
              Aggiungi
            </button>
          </div>
        </div>

        {/* Lista camerieri con QR code */}
        <h3 style={{ marginBottom: "1rem" }}>📋 Camerieri Attivi</h3>
        {camerieri.length === 0 ? (
          <p style={{ color: "#999", textAlign: "center", padding: "2rem" }}>
            Nessun cameriere presente. Aggiungine uno per generare il QR code.
          </p>
        ) : (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: "1.5rem" }}>
            {camerieri.map((cameriere) => (
              <div
                key={cameriere.id}
                style={{
                  padding: "1.5rem",
                  backgroundColor: "var(--color-surface)",
                  borderRadius: "12px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  textAlign: "center"
                }}
              >
<h4 style={{ marginTop: 0, marginBottom: "0.6rem", fontSize: "1.1rem" }}>
  {cameriere.nome}
</h4>

<div
  style={{
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.4rem",
    padding: "0.35rem 0.75rem",
    marginBottom: "1rem",
    borderRadius: "999px",
    fontSize: "0.78rem",
    fontWeight: "700",
    backgroundColor:
      cameriere.statoOperativo === "attivo"
        ? "rgba(76, 175, 80, 0.15)"
        : cameriere.statoOperativo === "standby"
          ? "rgba(255, 152, 0, 0.15)"
          : "rgba(158, 158, 158, 0.15)",
    color:
      cameriere.statoOperativo === "attivo"
        ? "#4CAF50"
        : cameriere.statoOperativo === "standby"
          ? "#FF9800"
          : "#9E9E9E",
    border:
      cameriere.statoOperativo === "attivo"
        ? "1px solid rgba(76, 175, 80, 0.35)"
        : cameriere.statoOperativo === "standby"
          ? "1px solid rgba(255, 152, 0, 0.35)"
          : "1px solid rgba(158, 158, 158, 0.35)"
  }}
>
  <span>
    {cameriere.statoOperativo === "attivo"
      ? "🟢"
      : cameriere.statoOperativo === "standby"
        ? "🟠"
        : "⚪"}
  </span>

  <span>
    {cameriere.statoOperativo === "attivo"
      ? "Attivo"
      : cameriere.statoOperativo === "standby"
        ? "Standby"
        : "Mai avviato"}
  </span>
</div>
                
{/* QR Code dedicato */}
                <div style={{ marginBottom: "1rem" }}>
                  <QRCodeCanvas 
                    value={`https://waiter-qrmenu.web.app/?locale=${localeTag}&cameriere=${cameriere.id}`}
                    size={150}
                    level="M"
                    includeMargin={true}
                  />
                </div>
                
                <p style={{ fontSize: "0.85rem", color: "#666", marginBottom: "1rem" }}>
                  Scansiona per prendere ordini come <strong>{cameriere.nome}</strong>
                </p>

                {(cameriere.categorieNotifica?.length > 0 || cameriere.categoriaNotifica) && (
                  <p style={{ 
                    fontSize: "0.8rem", 
                    color: "#FF9800", 
                    backgroundColor: "#FFF3E0", 
                    padding: "0.4rem", 
                    borderRadius: "6px",
                    marginBottom: "0.8rem",
                    fontWeight: "600"
                  }}>
                    🔔 Notifica: <strong>
                      {cameriere.categorieNotifica?.length > 0 
                        ? cameriere.categorieNotifica.join(", ")
                        : cameriere.categoriaNotifica}
                    </strong>
                  </p>
                )}

                <div style={{ display: "flex", gap: "0.5rem", flexDirection: "column" }}>
                  <button
                    onClick={() => {
                      setModaleCategoria(cameriere.id);
                      // Supporta sia il vecchio campo singolo che il nuovo array
                      const categorie = cameriere.categorieNotifica?.length > 0 
                        ? cameriere.categorieNotifica 
                        : cameriere.categoriaNotifica 
                          ? [cameriere.categoriaNotifica]
                          : [];
                      setCategorieSelezionate(categorie);
                    }}
                    style={{
                      padding: "0.5rem 1rem",
                      backgroundColor: "#FF9800",
                      color: "white",
                      border: "none",
                      borderRadius: "8px",
                      cursor: "pointer",
                      fontSize: "0.9rem"
                    }}
                  >
                    🔔 Imposta Categoria
                  </button>

<button
  onClick={async () => {
    await setDoc(
      doc(db, "camerieri", cameriere.id),
      {
  statoOperativo:
    cameriere.statoOperativo === "standby"
      ? "attivo"
      : "standby",
  ultimoAggiornamentoStato: new Date()
},
      { merge: true }
    );
  }}
  style={{
    padding: "0.5rem 1rem",
    backgroundColor:
      cameriere.statoOperativo === "standby"
        ? "#4CAF50"
        : "#FF9800",
    color: "white",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "0.9rem"
  }}
>
  {cameriere.statoOperativo === "standby"
    ? "▶️ Riattiva"
    : "⏸️ Standby"}
</button>

                  <button
                    onClick={() => eliminaCameriere(cameriere.id)}
                    style={{
                      padding: "0.5rem 1rem",
                      backgroundColor: "#f44336",
                      color: "white",
                      border: "none",
                      borderRadius: "8px",
                      cursor: "pointer",
                      fontSize: "0.9rem"
                    }}
                  >
                    🗑️ Elimina
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Modale selezione categoria */}
{modaleCategoria && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.55)",
      backdropFilter: "blur(14px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
      padding: "1rem"
    }}
    onClick={() => setModaleCategoria(null)}
  >
    <div
      style={{
        background: "#16181f",
        border: "1px solid rgba(255,255,255,0.08)",
        borderRadius: "28px",
        padding: "2rem",
        maxWidth: "420px",
        width: "100%",
        boxShadow: "0 24px 80px rgba(0,0,0,0.55)"
      }}
      onClick={(e) => e.stopPropagation()}
    >

      <div
        style={{
          fontSize: "2.5rem",
          textAlign: "center",
          marginBottom: "1rem"
        }}
      >
        🔔
      </div>

      <h3
        style={{
          margin: 0,
          color: "#fff",
          textAlign: "center",
          fontSize: "1.6rem",
          fontWeight: "700"
        }}
      >
        Categorie Notifica
      </h3>

      <p
        style={{
          color: "#aaa",
          textAlign: "center",
          marginTop: "1rem",
          lineHeight: 1.5,
          fontSize: "0.95rem"
        }}
      >
        Quando un cliente ordina un piatto di queste categorie,
        il cameriere riceverà una notifica realtime.
      </p>

      <div
        style={{
          marginTop: "1.5rem",
          maxHeight: "260px",
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          gap: "0.6rem"
        }}
      >
        {categorie.length === 0 ? (
          <div
            style={{
              color: "#777",
              textAlign: "center",
              padding: "1rem"
            }}
          >
            Nessuna categoria disponibile
          </div>
        ) : (
          categorie.map((cat, idx) => {

            const selected =
              categorieSelezionate.includes(cat);

            return (
              <label
                key={idx}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.8rem",
                  padding: "0.9rem 1rem",
                  borderRadius: "16px",
                  cursor: "pointer",
                  background: selected
                    ? "rgba(255,152,0,0.12)"
                    : "rgba(255,255,255,0.03)",
                  border: selected
                    ? "1px solid rgba(255,152,0,0.35)"
                    : "1px solid rgba(255,255,255,0.05)",
                  transition: "all 0.18s ease",
                  color: "#fff"
                }}
              >
                <input
                  type="checkbox"
                  checked={selected}
                  onChange={(e) => {

                    if (e.target.checked) {

                      setCategorieSelezionate([
                        ...categorieSelezionate,
                        cat
                      ]);

                    } else {

                      setCategorieSelezionate(
                        categorieSelezionate.filter(
                          c => c !== cat
                        )
                      );

                    }

                  }}
                  style={{
                    width: "18px",
                    height: "18px",
                    accentColor: "#ff9800",
                    cursor: "pointer"
                  }}
                />

                <span
                  style={{
                    fontSize: "0.96rem",
                    fontWeight: "500"
                  }}
                >
                  {cat}
                </span>

              </label>
            );

          })
        )}
      </div>

      <div
        style={{
          marginTop: "1.7rem",
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "0.8rem"
        }}
      >
        <button
          onClick={() =>
            salvaCategoriaNotifica(
              modaleCategoria
            )
          }
          style={{
            padding: "0.95rem",
            borderRadius: "16px",
            border: "none",
            background: "#ff9800",
            color: "#fff",
            fontWeight: "700",
            fontSize: "0.95rem",
            cursor: "pointer"
          }}
        >
          💾 Salva
        </button>

        <button
          onClick={() => {
            setModaleCategoria(null);
            setCategorieSelezionate([]);
          }}
          style={{
            padding: "0.95rem",
            borderRadius: "16px",
            border: "1px solid rgba(255,255,255,0.08)",
            background: "rgba(255,255,255,0.06)",
            color: "#fff",
            fontWeight: "600",
            fontSize: "0.95rem",
            cursor: "pointer"
          }}
        >
          Chiudi
        </button>
      </div>

    </div>
  </div>
)}
      </div>
    </>
  );
}

export default GestioneCamerieri;
